export default "__VITE_ASSET__10e3dbb8__"